import { IAppointmentProps } from "../../customer_profile_interface";
import AppointmentTableComponent from "./AppointmentsTable";

const AppointmentsHistory: React.FC<IAppointmentProps> = (_props) => {
  return (
    <>
      <AppointmentTableComponent />
    </>
  );
};

export default AppointmentsHistory;
